const inputStep = 0.016

export default inputStep
